import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import { PropType } from "vue";
  import { useRouter } from "vue-router";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    items: {
      type: Array as PropType<string[]>,
      default() {
        return [];
      },
    },
  },
  setup(__props) {

  const router = useRouter();
  
  const goTo = (data) => {
    router.push({ name: data.name });
  };
  const goHome = () => {
    router.push({ name: "home" });
  };

return (_ctx: any,_cache: any) => {
  const _component_icon_apps = _resolveComponent("icon-apps")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_openBlock(), _createBlock(_component_a_breadcrumb, { class: "container-breadcrumb" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_breadcrumb_item, {
        onClick: goHome,
        style: {"cursor":"pointer"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_icon_apps)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: item }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})